import { createFileRoute, redirect } from '@tanstack/react-router'
import { LegacyIframe } from '@shared/components'

export const Route = createFileRoute('/_auth/reports')({
  component: RouteComponent,
  beforeLoad: ({ context: { scopedEnablements } }) => {
    if (!scopedEnablements.global().hasStandardEnablement('Report', 'READ')) {
      throw redirect({
        to: '/403',
        replace: true,
      })
    }
  },
})

function RouteComponent() {
  return <LegacyIframe src="reports" />
}
